<template>
    <div class="index-body">
        <!--首页顶部-->
        <div class="index-top">
            <div class="top-left">
                <div class="top-icon"><img src="../assets/imgs/icon.png" alt=""></div>
                <div class="icon-font">
                    <div class="qiqu-font">{{$t("appName") }}</div>
                </div>
            </div>
            <div class="top-right">
                <div class="search-btn" @click="go.goSearch(0)">
                    <img src="../assets/imgs/search.png" alt="">
                </div>
                <div class="login-reg" v-if="loginUserID==0">
                    <div class="login-btn" @click="go.goLogin">{{$t("login") }}</div>
                    <div class="top-line"></div>
                    <div class="reg-btn" @click="go.goReg">{{$t("reg") }}</div>
                </div>
                <div class="has-login" v-if="loginUserID>0">
                    <div class="user-icon" @click="go.goPersonal"></div>
                    <div class="go-book"  @click="go.goMybook">{{$t("shelf")}}</div>
                </div>
            </div>
        </div>
        <!--首页分类频道-->
        <div class="index-cate">
            <div class="last-read" v-if="lastRead.book_item_id>0" @click="goRead(lastRead.book_item_id)">
                <img src="../assets/imgs/last.png" alt="">
                <div class="last-font">{{$t("lastRead")}}：{{lastRead.book_item_title}}</div>
            </div>
            <div class="cate-area">
                <router-link tag="div" active-class="cate-index" :to="{ path: '/homepage', query: {}}">
                    <div class="cate-item">
                        <img src="../assets/imgs/index.png" alt="">
                        <div class="cate-font">{{$t("index") }}</div>
                    </div>
                </router-link>
                <router-link tag="div" active-class="woman-select" :to="{ path: '/woman', query: {sex:-1}}">
                    <div class="cate-item">
                        <img src="../assets/imgs/woman.png" alt="">
                        <div class="cate-font">{{$t("woman") }}</div>
                    </div>
                </router-link>
                <router-link tag="div" active-class="end-select" to="/end">
                    <div class="cate-item">
                        <img src="../assets/imgs/end.png" alt="">
                        <div class="cate-font">{{$t("end") }}</div>
                    </div>
                </router-link>
                <router-link tag="div" active-class="rank-select" to="/rank">
                    <div class="cate-item">
                        <img src="../assets/imgs/rank.png" alt="">
                        <div class="cate-font">{{$t("rank") }}</div>
                    </div>
                </router-link>
            </div>
        </div>
        <!--内容区域-->
        <div class="index-con">
      			<transition>
            <!--<transition name="move">-->
                <router-view></router-view>
            </transition>
        </div>
        <!--提示-->
        <div class="tip-one" v-if="platform=='IOS'">
            <div class="tip-left"><img src="../assets/imgs/icon.png" ></div>
            <div class="tip-right">
                <p>
                    <span>{{$t("click")}}“</span>
                    <img src="../assets/imgs/load.png" alt="">
                    <span>{{$t("then")}}</span>
                    <span class="coll-span">{{$t("fav")}}</span>
                    <span>”</span>
                </p>
                <p>
                    <span>{{$t("readNextTime")}}</span>
                </p>
            </div>
            <div class="close-tip"><img src="../assets/imgs/closeTip.png" @click="hideTipOne"></div>
        </div>
        <div class="tip-two" v-if="platform=='Android'">
            <div class="tip-left"><img src="../assets/imgs/icon.png" ></div>
            <div class="tip-right">
                <p>
                    <span>{{$t("click")}}“</span>
                    <img src="../assets/imgs/dian.png" alt="">
                    <span>{{$t("then")}}</span>
                    <span class="coll-span">{{$t("fav")}}</span>
                    <span>”</span>
                </p>
                <p>
                    <span>{{$t("readNextTime")}}</span>
                </p>
            </div>
            <div class="close-tip"><img src="../assets/imgs/closeTip.png" @click="hideTipTwo"></div>
        </div>
    </div>
</template>

<script>
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "index",
  components: {
    pagebottom
  },
  data() {
    return {
      msg: "",
      lastRead: {},
      loginUserID: 0,
      lists: [],
      platform: false
    };
  },
  mounted: function() {
    this.loginUserID =
      parseInt(localStorage.getItem("loginUserID")) > 0
        ? localStorage.getItem("loginUserID")
        : 0;
    //设置语言
    // this.$i18n.locale = "fan";
    this.getLastRead();
    var isFav = localStorage.getItem("fav_tool_bar");
    if (!isFav) {
      this.platform = this.go.getMobileBrowser();
    }

    //toast使用 简写 跟 自定义
    // this.$toast("简写提示");
    // this.$toast({
    //     message:'自定义提示',
    //     position:'top',//'top bottom middle
    //     duration:1000,//持续时间
    //     className:'',//自定义样式类名
    // });
  },
  methods: {
    hideTipOne() {
      localStorage.setItem("fav_tool_bar", true);
      this.platform = false;
    },
    hideTipTwo() {
      localStorage.setItem("fav_tool_bar", true);
      this.platform = false;
    },
    getLastRead() {
      this.req.indexLastRead().then(res => {
        if (res && res.last_read) {
          this.lastRead = res.last_read;
        }
      });
    },
    goRead(id) {
      localStorage.setItem("bookName", this.lastRead.book_title);
      this.go.goRead(id);
    }
  }
};
</script>

<style scoped>
.index-body {
  width: 100%;
  height: auto;
  background: #f2f2f2;
}
/*首页顶部*/
.index-top {
  width: 100%;
  height: 1rem;
  background: #ff1f4f;
  box-sizing: border-box;
  padding: 0 0.4rem 0 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-left,
.top-right {
  display: flex;
  align-items: center;
}
.top-icon {
  width: 0.62rem;
  height: 0.62rem;
  margin-right: 0.2rem;
}
.top-icon img {
  width: 0.62rem;
  height: 0.62rem;
  display: block;
}
.icon-font {
  width: auto;
  height: 0.62rem;
}
.qiqu-font {
  color: #fff;
  font-size: 0.3rem;
  line-height: 0.6rem;
  padding: 0.04rem 0 0.06rem;
}
.qiqu-adress {
  font-size: 0.16rem;
  color: #fff;
  line-height: 0.16rem;
}
.search-btn {
  width: 0.38rem;
  height: 0.42rem;
  margin-right: 0.4rem;
}
.search-btn img {
  width: 0.38rem;
  height: 0.42rem;
  display: block;
}
.login-reg {
  display: flex;
  font-size: 0.3rem;
  line-height: 0.3rem;
  color: #fff;
  align-items: center;
}
.top-line {
  width: 0.02rem;
  height: 0.36rem;
  background: #fff;
}
.login-btn {
  padding-right: 0.2rem;
}
.reg-btn {
  padding-left: 0.18rem;
}
.has-login {
  width: 1.7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-icon {
  width: 0.4rem;
  height: 0.4rem;
  background: url("../assets/imgs/user-center.png") no-repeat center/cover;
}
.go-book {
  width: 0.88rem;
  height: 0.52rem;
  border: 0.02rem solid #ffffff;
  border-radius: 0.08rem;
  font-size: 0.28rem;
  line-height: 0.52rem;
  text-align: center;
  box-sizing: border-box;
  color: #ffffff;
}
/*首页分类*/
.index-cate {
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.last-read {
  width: 7rem;
  height: 0.8rem;
  background: #f5f5f5;
  box-sizing: border-box;
  border-radius: 0.06rem;
  padding: 0.24rem 0 0 0.28rem;
  margin: 0 auto;
  display: flex;
  margin-bottom: 0.38rem;
}
.last-read img {
  display: block;
  width: 0.32rem;
  height: 0.32rem;
}
.last-font {
  padding-left: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.32rem;
  color: #fe814e;
}
.cate-area {
  width: 100%;
  height: auto;
  display: flex;
  box-sizing: border-box;
  padding: 0 0.3rem;
  justify-content: space-between;
}
.cate-item {
  width: auto;
  text-align: center;
}
.cate-item img {
  display: block;
  width: 0.78rem;
  height: 0.78rem;
}
.cate-font {
  font-size: 0.26rem;
  line-height: 0.26rem;
  padding-top: 0.22rem;
}
.cate-index {
  color: #e6a5d2;
}
.woman-select {
  color: #ff817a;
}
.man-select {
  color: #69b7ff;
}
.end-select {
  color: #a5c783;
}
.rank-select {
  color: #ffab5f;
}
.index-con {
  position: relative;
}
/*过渡动画*/
.move-enter-active,
.move-leave-active {
  transition: all 0.8s;
}
.move-enter {
  transform: translateX(100%);
}
.move-enter-to,
.move-leave {
  transform: translateX(0);
}
.move-leave-to {
  transform: translateX(-100%);
}
/*提示*/
.tip-one,
.tip-two {
  width: 5.36rem;
  height: 1.46rem;
  background: #eaeaea;
  position: fixed;
  box-sizing: border-box;
  padding: 0.24rem 0 0 0.4rem;
  display: flex;
  z-index: 99;
}
.tip-one {
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  bottom: 0.32rem;
}
.tip-one::after {
  width: 0;
  content: "";
  border-top: 0.32rem solid #eaeaea;
  border-left: 0.28rem solid transparent;
  border-right: 0.28rem solid transparent;
  position: absolute;
  bottom: -0.32rem;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.tip-two {
  top: 0.32rem;
  right: 0.2rem;
}
.tip-two::before {
  width: 0;
  content: "";
  border-bottom: 0.32rem solid #eaeaea;
  border-left: 0.28rem solid transparent;
  border-right: 0.28rem solid transparent;
  position: absolute;
  top: -0.32rem;
  right: 0;
}
.tip-left {
  width: 0.96rem;
  height: 0.96rem;
}
.tip-left img {
  display: block;
  width: 0.96rem;
  height: 0.96rem;
}
.tip-right {
  font-size: 0.2rem;
  padding-left: 0.2rem;
  padding-top: 0.14rem;
  line-height: 0.4rem;
}
.tip-right img {
  height: 0.26rem;
  display: inline-block;
}
.close-tip {
  width: 0.22rem;
  height: 0.22rem;
  position: absolute;
  top: 0.14rem;
  right: 0.4rem;
}
.close-tip img {
  display: block;
  width: 0.22rem;
  height: 0.22rem;
}
.tip-right .coll-span {
  color: #ff1f4f;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue